import { ActionType, getType } from 'typesafe-actions';
import * as actions from '@actions/notification-rules';
import { ResultState } from '@rootCommon/types/common';
import { NotificationRule } from '@rootCommon/types/site';

type Action = ActionType<typeof actions>;
export type NotificationRulesState = ResultState<NotificationRule[] | null>;

const initState: NotificationRulesState = {
  data: null,
  loading: false,
  error: null,
};

export const notificationRulesReducer = (state = initState, action: Action): NotificationRulesState => {
  switch (action.type) {
    // fetch
    case getType(actions.fetchNotificationRules.request):
      return { ...state, loading: true };
    case getType(actions.fetchNotificationRules.success):
      return { ...state, loading: false, data: action.payload };
    case getType(actions.fetchNotificationRules.failure):
      return { ...state, loading: false, error: action.payload };

      // update
    case getType(actions.updateNotificationRules.request):
      return { ...state, loading: true };
    case getType(actions.updateNotificationRules.success):
      return { ...state, loading: false, data: action.payload };
    case getType(actions.updateNotificationRules.failure):
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default notificationRulesReducer;
